import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { PromotionValidation } from 'uplisting-frontend/validations';

export default class PromotionRepositoryService extends BaseRepositoryService<
  ModelRegistry['promotion']
> {
  recordName = 'promotion';
  implementMethods = [
    'createRecord',
    'findAll',
    'peekAll',
    'buildChangeset',
    'unloadAll',
  ];

  validation = PromotionValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/promotion': PromotionRepositoryService;
  }
}
